module.exports = __webpack_public_path__ + "img/paypal.89a5fac2.png";